import { Link } from "react-router";
import { RouteFactory } from "@app/routePaths";
import IconFactory from "@components/Icon/IconFactory";
import { IconTypeEnum } from "@components/Icon/utils/types";
import { cn } from "@util/helpers";

type SearchTriggerProps = {
  /** This is the classname of the component. */
  className?: string;
};

export default function SearchTrigger({ className }: SearchTriggerProps) {
  return (
    <Link
      reloadDocument
      className={cn(
        "flex cursor-pointer items-center justify-center opacity-100 duration-300",
        "border-0 p-1 text-gray-850 outline-none focus-within:outline-0 focus:outline-0 lg:hover:rounded-full lg:hover:bg-gray-250",
        className
      )}
      aria-label="Search"
      to={RouteFactory.search}
    >
      <IconFactory
        type={IconTypeEnum.search}
        size={24}
        data-testid="search-icon"
      />

      <p className="m-0 block pl-1 font-poppins text-sm font-medium tracking-2% lg:hidden">
        Search
      </p>
    </Link>
  );
}
